import {
  AuthenticationActionTypes,
  ISignUpPayload,
  ISignInPayload,
  ISsoSignInPayload,
  ISignInSuccessPayload,
  IPasswordNewPayload,
  IUpdatePasswordPayload,
  ICreateOTPPayload,
  IVerifyOTPPayload,
} from './types'

export const signUp = (payload: ISignUpPayload)=> ({
  type: AuthenticationActionTypes.SIGN_UP,
  payload
})

export const signUpSuccess = () => ({
  type: AuthenticationActionTypes.SIGN_UP_SUCCESS,
})

export const signUpFailure = () => ({
  type: AuthenticationActionTypes.SIGN_UP_FAILURE,
})

export const signIn = (payload: ISignInPayload) => ({
  type: AuthenticationActionTypes.SIGN_IN,
  payload,
})

export const ssoSignIn = (payload: ISsoSignInPayload) => ({
  type: AuthenticationActionTypes.SSO_SIGN_IN,
  payload,
})

export const signInSuccess = (payload: ISignInSuccessPayload) => ({
  type: AuthenticationActionTypes.SIGN_IN_SUCCESS,
  payload,
})

export const signInFailure = () => ({
  type: AuthenticationActionTypes.SIGN_IN_FAILURE,
})

export const passwordNew = (payload: IPasswordNewPayload) => ({
  type: AuthenticationActionTypes.PASSWORD_NEW,
  payload
})

export const passwordNewSuccess = () => ({
  type: AuthenticationActionTypes.PASSWORD_NEW_SUCCESS,
})

export const passwordNewFailure = () => ({
  type: AuthenticationActionTypes.PASSWORD_NEW_FAILURE,
})

export const updatePassword = (payload: IUpdatePasswordPayload) => ({
  type: AuthenticationActionTypes.UPDATE_PASSWORD,
  payload
})

export const updatePasswordSuccess = () => ({
  type: AuthenticationActionTypes.UPDATE_PASSWORD_SUCCESS
})

export const updatePasswordFailure = () => ({
  type: AuthenticationActionTypes.UPDATE_PASSWORD_FAILURE,
})

export const createOTP = (payload: ICreateOTPPayload) => ({
  type: AuthenticationActionTypes.CREATE_OTP,
  payload
})

export const createOTPSuccess = () => ({
  type: AuthenticationActionTypes.CREATE_OTP_SUCCESS,
})

export const createOTPFailure = () => ({
  type: AuthenticationActionTypes.CREATE_OTP_FAILURE,
})

export const verifyOTP = (payload: IVerifyOTPPayload) => ({
  type: AuthenticationActionTypes.VERIFY_OTP,
  payload,
})

export const verifyOTPSuccess = () => ({
  type: AuthenticationActionTypes.VERIFY_OTP_SUCCESS,
})

export const verifyOTPFailure = () => ({
  type: AuthenticationActionTypes.VERIFY_OTP_FAILURE,
})
